export function performOnNextFrame(callback: Function): number {
  // Wait for next frame to measure visual changes (https://nolanlawson.com/2018/09/25/accurately-measuring-layout-on-the-web/)
  return requestAnimationFrame(() => setTimeout(callback, 0));
}
